import { SxProps, Theme } from "@mui/material";

import { APIconName } from "./APIcon";
import APIconButton from "./APIconButton";

const APToggleButton = ({
  isToggled,
  onToggle,
  toggledOnIcon,
  toggledOffIcon,
  sx,
}: {
  isToggled: boolean;
  onToggle: (newVisibility: boolean) => void;
  toggledOnIcon: APIconName;
  toggledOffIcon: APIconName;
  sx?: SxProps<Theme>;
}) => {
  return (
    <APIconButton
      iconName={isToggled ? toggledOnIcon : toggledOffIcon}
      onClick={() => onToggle(!isToggled)}
      isFaded={!isToggled}
      sx={sx}
    />
  );
};

export default APToggleButton;
